import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { GrayButton, OutlineButton, Tooltip } from "../../ui";
import { DIALOGS } from "../../constants/dialogs";
import { useDialog, useProfileOptions, useSelectedProfileId } from "../../hooks";
import { formatPhone, isValidPhone } from "../../utils";
const BUTTON_LABEL = "Сохранить расчеты";
export const SaveBusinessPlanDraftButton = ({ name, oldId, isGrayButton, isRetail, cityId, size, data, defaultParams, defaultRequestParams, requestValues, disableTooltip, }) => {
    const openDialog = useDialog();
    const [profileOptions] = useProfileOptions();
    const [selectedProfileId] = useSelectedProfileId();
    const currentOption = useMemo(() => profileOptions?.find(item => item.value === selectedProfileId), [profileOptions, selectedProfileId]);
    const currentUserProfileProps = useMemo(() => {
        return {
            ...currentOption?.values,
            user_phone: isValidPhone(currentOption.values.user_phone) ? formatPhone(currentOption.values.user_phone) : currentOption.values.user_phone,
            user_contact_phone: isValidPhone(currentOption.values.user_contact_phone) ? formatPhone(currentOption.values.user_contact_phone) : currentOption.values.user_contact_phone,
        };
    }, [currentOption]);
    return (_jsx(Tooltip, { delay: [1000, 0], wrapperWidth: "calc(100% - 0.5rem)", content: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0434\u043B\u044F \u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u043B\u0430\u043D\u0430 \u0431\u0443\u0434\u0443\u0442 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B \u0432 \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \u00AB\u041C\u043E\u0438 \u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u043B\u0430\u043D\u044B\u00BB. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E \u043F\u043E\u0437\u0436\u0435", disabled: !data.is_download || disableTooltip, children: isGrayButton ? (_jsx(GrayButton, { buttonSize: "xs", width: "100%", noWrap: true, disabled: !data.is_download, disabledTooltipPlacement: "top", disabledTooltip: !data.is_download
                ? isRetail
                    ? "Срок окупаемости вложений в бизнес по выбранному типовому формату превышает 5 лет" +
                        " в связи с высокой стоимостью аренды помещения, большим фондом оплаты труда" +
                        " и значительным объемом инвестиций. Рекомендуем выбрать другой типовой формат," +
                        " другой вид бизнеса или другое месторасположение"
                    : "Выбранная территория недоступна к открытию бизнеса/расчету примерного бизнес-плана"
                : undefined, onClick: () => {
                openDialog(DIALOGS.SAVE_BUSINESS_PLAN_DIALOG, {
                    name,
                    oldId,
                    isRetail,
                    isDraft: true,
                    cityId,
                    size,
                    data,
                    defaultParams,
                    defaultRequestParams,
                    requestValues: {
                        ...requestValues,
                        ...currentUserProfileProps,
                    },
                });
            }, children: BUTTON_LABEL })) : (_jsx(OutlineButton, { buttonSize: "xs", width: "100%", noWrap: true, disabled: !data.is_download, disabledTooltipPlacement: "top", disabledTooltip: !data.is_download
                ? isRetail
                    ? "Срок окупаемости вложений в бизнес по выбранному типовому формату превышает 5 лет" +
                        " в связи с высокой стоимостью аренды помещения, большим фондом оплаты труда" +
                        " и значительным объемом инвестиций. Рекомендуем выбрать другой типовой формат," +
                        " другой вид бизнеса или другое месторасположение."
                    : "Выбранная территория недоступна к открытию бизнеса/расчету примерного бизнес-плана."
                : undefined, onClick: () => {
                openDialog(DIALOGS.SAVE_BUSINESS_PLAN_DIALOG, {
                    name,
                    oldId,
                    isRetail,
                    isDraft: true,
                    cityId,
                    size,
                    data,
                    defaultParams,
                    defaultRequestParams,
                    requestValues: {
                        ...requestValues,
                        ...currentUserProfileProps,
                    },
                });
            }, children: BUTTON_LABEL })) }));
};
